<template>
    <div class="modal-backdrop">
        <div class="modal fade in">
            <div class="modal-dialog" aria-labelledby="modalTitle" role="alertdialog" aria-describedby="modalDescription">
                <div class="modal-content" tabindex="0" role="document" :style="{width: modalWidth}">
                    <header id="modalTitle" class="modal-header">
                        <div class="header-content">
                            <slot name="header">
                                <h4 class="modal-title">Default Modal Header</h4>                    
                            </slot>
                            <button type="button" class="btn-close" @click="close" aria-label="Close modal">
                                <v-icon name="times" />
                            </button>
                        </div>
                    </header>

                    <section id="modalDescription" class="modal-body">
                        <slot name="body">
                            <p>Default Modal Description</p>
                        </slot>                       
                    </section>

                    <footer class="modal-footer margin10">
                        <slot name="footer"></slot>
                    </footer>
                </div>
            </div>   
        </div>
    </div>
</template>

<script>
export default {
    name: 'Modal',
    data() {
        return {
            modalWidth: ''
        }
    },
    methods: {
        close() {
            this.$emit('close')
        }
    }
}
</script>

<style scoped>
.modal-backdrop {
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

.modal {
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    min-width: 400px;
}

.modal-header {
    display: flex;
    justify-content: space-between;
}

.header-content {
    width: 100%;
}

    .header-content .modal-title, .header-content .btn-close {
        display: inline-block;
        vertical-align: middle;
        font-weight: bold;
    }

    .header-content .modal-title {
        width: 92%;
    }

.modal-body {
    position: relative;
    padding: 20px 10px;
}

.btn-close {
    border: none;
    font-size: 20px;
    cursor: pointer;
    background: transparent !important;
    color: #3276b1 !important;
    outline: none;
    padding: 0;
}

.modal-footer .btn-cancel {
    color: #ffffff;
}
</style>
